import type { Report } from '../../../stores/types'
import { chartSpecForView, isSankeyView, type SankeyView } from '../sankeyViews'
import { CHART_EXPORT_ATTRIBUTE } from './chartImages'

export const CHART_VIEW_ATTRIBUTE = 'data-chart-view'

// The picked view lives in the on-screen chart, so read it from the page
// the same way the chart images are read.
export function collectChartViews(chartIds: string[]): Map<string, SankeyView> {
  const views = new Map<string, SankeyView>()
  for (const chartId of chartIds) {
    const view = document
      .querySelector(`[${CHART_EXPORT_ATTRIBUTE}="${CSS.escape(chartId)}"]`)
      ?.getAttribute(CHART_VIEW_ATTRIBUTE)
    if (isSankeyView(view)) views.set(chartId, view)
  }
  return views
}

export function applyChartViews(
  report: Report,
  views: Map<string, SankeyView>,
): Report {
  return {
    ...report,
    sections: report.sections.map((section) => ({
      ...section,
      charts: section.charts?.map((chart) => {
        const view = views.get(chart.id ?? '')
        const shown = view ? chartSpecForView(chart, view) : chart
        return shown.type === 'sankey' && !shown.links?.length ? chart : shown
      }),
    })),
  }
}
